import { render, staticRenderFns } from "./printCFQuoted.vue?vue&type=template&id=bb068bfe&scoped=true&"
import script from "./printCFQuoted.vue?vue&type=script&lang=js&"
export * from "./printCFQuoted.vue?vue&type=script&lang=js&"
import style0 from "./printCFQuoted.vue?vue&type=style&index=0&id=bb068bfe&lang=less&scoped=true&"
import style1 from "./printCFQuoted.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb068bfe",
  null
  
)

component.options.__file = "printCFQuoted.vue"
export default component.exports